import React from "react";
import { Box, Typography } from "@mui/material/";
import styles from "./styles";
import { strings } from "../../i18n";

const AssetProgresBar = ({ data }) => {
    const readings = [
        {
            name: strings("unchecked"),
            value: data?.assetSummary?.auditAsset?.unchecked,
            color: "#b4b8ba"
        },
        {
            name: strings("seen"),
            value: data?.assetSummary?.auditAsset?.seen,
            color: "#8eddaf"
        },
        {
            name: strings("excluded"),
            value: data?.assetSummary?.auditAsset?.excluded,
            color: "#f395aa"
        },
        // {
        //     name: strings("pending"),
        //     value: data.assetSummary.auditAsset.pending,
        //     color: "#7fbcff"
        // },
        {
            name: strings("approved"),
            value: data?.assetSummary?.auditAsset?.approved,
            color: "#007aff"
        },
        {
            name: strings("rejected"),
            value: data.assetSummary.auditAsset?.rejected,
            color: "#EE315E"
        },
        {
            name: strings("unexpected"),
            value: data?.assetSummary?.altAsset?.total,
            color: "#fdd87d"
        }
    ];

    const totalValue = readings.reduce((sum, item) => sum + item.value, 0);
    const normalizedReadings = readings.map((item) => ({
        ...item,
        dataValue: item.value,
        value: (item.value / totalValue) * 100
    }));

    // Unexpected (alt) assets are their own bar segment above — found on
    // site but never part of the audit's own scope. Adding altAsset.total
    // into this headline count inflated it with assets that were never
    // "expected", e.g. 2 expected + 1 non-mandatory + 4 unexpected showed as
    // "7 assets" instead of the audit's real scope of 3.
    const totalAssets =
        data.status && data.status.name === "in review"
            ? `${data.assetSummary?.auditAsset?.approved} of ${
                  data.assetSummary?.auditAsset?.total
              }
              ${strings("assets")}`
            : `${
                  data.assetSummary?.auditAsset?.total
              }
              ${strings("assets")}`;

    const bars =
        normalizedReadings &&
        normalizedReadings.length &&
        normalizedReadings.map((item, i) => {
            if (item.value > 0) {
                return (
                    <Box
                        className="bar"
                        title={`${item.dataValue} ${item.name}`}
                        sx={styles.valueBar}
                        style={{
                            backgroundColor: item.color,
                            width: item.value + "%"
                        }}
                        key={i}
                    ></Box>
                );
            }
            return null;
        });

    return (
        <Box sx={styles.assetProgressBar}>
            <Typography variant="caption">{`${totalAssets}`}</Typography>
            <Box sx={styles.bars}>{bars === "" ? "" : bars}</Box>
        </Box>
    );
};

export default AssetProgresBar;
